<form [formGroup]="form">
  @if (errorResponseMessages.length > 0) {
    <div class="row">
      <div class="col-12 margin-bottom">
        <app-alert
          [type]="alertType.danger"
          [technicalDetails]="errorResponseMessages"
          [header]="'error_workspace_header' | translate"
          [message]="'migrate_workspace_error' | translate"
        >
        </app-alert>
      </div>
    </div>
  }
  <div class="row">
    <div class="col-auto">
      <h2 class="h1">{{ 'table_column_workspaces' | translate }}</h2>
    </div>
  </div>
  <div class="row justify-content-between">
    <div class="col-auto">
      <app-searchbox
        id="taskNameFilter"
        role="search"
        [formControlName]="$workspace.name"
        [label]="'search_by_workspace_name_url' | translate"
        [placeholder]="'form_search' | translate"
      >
      </app-searchbox>
    </div>
    <div class="col-auto align-self-center justify-content-end">
      @if (displayMigrateWorkspace$ | async) {
        <button id="migrate-workspace" class="btn btn-link me-1" type="button" (click)="openMigrateWorkspaceModal()">
          <svg viewBox="0 0 512 512" class="edit-icon">
            <use xlink:href="#exchange"></use>
          </svg>
          {{ 'migrate_workspace' | translate }}
        </button>
      }
      @if (displayMigrationTroubleshooting$ | async) {
        <button class="btn btn-link me-1" id="migration-troubleshooting" type="button" (click)="openMigrationTroubleshootModal()">
          {{ 'migration_troubleshooting' | translate }}
        </button>
      }
      <button
        *appHasPermissions="workspaceCreateRequiredSecurity"
        id="create-workspace"
        class="btn btn-primary"
        type="button"
        (click)="onCreateWorkspace()"
      >
        {{ 'create_workspace' | translate }}
      </button>
    </div>
  </div>

  @if (
    {
      message: workspacesCreationMessage$ | async,
      bannerState: workspacesCreationBannerState$ | async,
    };
    as workspacesCreationBanner
  ) {
    @if (workspacesCreationBanner.message && workspacesCreationBanner.bannerState) {
      <ds-banner
        data-test-id="workspace-loaded-banner"
        class="d-block mt-4"
        [state]="workspacesCreationBanner.bannerState"
        [showTitle]="false"
        [showAction]="false"
        [showCloseButton]="true"
        (closed)="onWorkspacesCreationBannerClosed()"
      >
        <div ds-banner-body>
          {{ workspacesCreationBanner.message }}
        </div>
      </ds-banner>
    }
  }

  <div class="row">
    <div class="col-12">
      <app-tenant-workspaces-table
        [isFiltered]="isFiltered"
        [workspaces$]="workspaces$"
        [reloadWorkspaces$]="reloadWorkspaces$"
      ></app-tenant-workspaces-table>
    </div>
  </div>
</form>
